import { Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { getPaymentMethods } from 'store/user-service/selector';
import { setNotEnoughTokensError } from 'store/user-service/userSlice';

import { NamespacesList } from 'core/enums/common';
import { useGetPaymentMethods } from 'core/hooks/useGetPaymentMethods';

import { UpdatePaymentInformationModal } from 'components/Profile/Subscription/UpdatePaymentInformation';
import { InfoModal } from 'components/shared/Modal/Info';

import { ReactComponent as Error } from 'assets/icons/error.svg';

export const NoPaymentMethodModal = () => {
	const { t: paymentTranslate } = useTranslation(NamespacesList['payment']);
	const { gettingPaymentLoading, handleGetAllPaymentsMethods } = useGetPaymentMethods();

	const paymentMethods = useSelector(getPaymentMethods);
	const dispatch = useDispatch();

	const [open, setOpen] = useState<boolean>(true);
	const [isOpenUpdatePaymentMethod, setIsOpenUpdatePaymentMethod] = useState<boolean>(false);

	const handleResetTokensErrors = () => {
		dispatch(setNotEnoughTokensError(false));
	};

	const handleCloseModal = () => {
		setOpen(false);
		handleResetTokensErrors();
	};

	const handleOpenPaymentModal = () => {
		setOpen(false);
		setIsOpenUpdatePaymentMethod(true);
	};

	const handleClosePaymentModal = () => {
		setIsOpenUpdatePaymentMethod(false);
		handleResetTokensErrors();
	};

	return (
		<>
			<InfoModal
				isOpen={open}
				onClose={handleCloseModal}
				image={<Error />}
				title={paymentTranslate('modals.noPaymentMethod.title')}
				description={paymentTranslate('modals.noPaymentMethod.description')}
				buttons={
					<>
						<Button
							sx={{
								height: '44px',
								width: { xs: '49%', sm: '215px' },
								borderRadius: '8px',
								textTransform: 'none',
								fontSize: '16px',
								fontWeight: '700',
								marginTop: '24px',
							}}
							variant="outlined"
							color="primary"
							onClick={handleCloseModal}
						>
							{paymentTranslate('modals.noPaymentMethod.decline')}
						</Button>

						<Button
							sx={{
								height: '44px',
								width: { xs: '49%', sm: '215px' },
								borderRadius: '8px',
								textTransform: 'none',
								fontSize: '16px',
								fontWeight: '700',
								marginTop: '24px',
							}}
							variant="contained"
							color="primary"
							onClick={handleOpenPaymentModal}
						>
							{paymentTranslate('modals.noPaymentMethod.confirm')}
						</Button>
					</>
				}
			/>
			<UpdatePaymentInformationModal
				getPaymentsMethods={handleGetAllPaymentsMethods}
				gettingPaymentsLoading={gettingPaymentLoading}
				paymentMethods={paymentMethods}
				isOpen={isOpenUpdatePaymentMethod}
				onClose={handleClosePaymentModal}
			/>
		</>
	);
};
